import { render, staticRenderFns } from "./PlayersPieChart.vue?vue&type=template&id=096847a4&scoped=true"
import script from "./PlayersPieChart.vue?vue&type=script&lang=js"
export * from "./PlayersPieChart.vue?vue&type=script&lang=js"
import style0 from "./PlayersPieChart.vue?vue&type=style&index=0&id=096847a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096847a4",
  null
  
)

export default component.exports